import { useContext } from 'react';
import { blackCardContext } from 'root/src/client/v2/common/components/BlackCard/contexts/blackCardContext';
export const useBlackCardContext = () => {
    const context = useContext(blackCardContext);
    if (!context) {
        throw new Error('useBlackCardContext must be used within a BlackCardContextProvider');
    }
    return context;
};
